import {motion} from 'framer-motion';
import Card from '../../shared/Card';
import GeneralContext from '../../../context/GeneralContext';
import ButtonFunction from '../../shared/ButtonFunction';
import { useContext, useState } from 'react';
import { fetchBody } from '../../../utils/fetch';
import TextInputHorizontalTag from "../../shared/TextInputHorizontalTag";
import Select from '../../shared/Select';

function RestoreUserQuestion() {

    const {
        userResetData,
        changeCurrentMenu,
        changeModalTitle,
        changeModalText,
        changeModalType
    } = useContext(GeneralContext);

    const [questions] = useState([
        {
            id: 0,
            value: '',
            text: ''
        },
        {
            id: 1,
            value: '¿En qué año se conocieron tus padres?',
            text: '¿En qué año se conocieron tus padres?'
        },
        {
            id: 2,
            value: '¿Cuál es el nombre de tu primera mascota',
            text: '¿Cuál es el nombre de tu primera mascota'
        },
        {
            id: 3,
            value: '¿En qué escuela estudiaste la primaria?',
            text: '¿En qué escuela estudiaste la primaria?'
        }
    ]);

    const [selectedQuestion, setSelectedQuestion] = useState('');
    const changeSelectedQuestion = (e) => {
        setSelectedQuestion(e.target.value);
    }

    const [answer, setAnswer] = useState('');
    const changeAnswer = (e) => {
        setAnswer(e.target.value);
    }

    const newQuestionFunction = async () => {
        const modal = document.getElementById("myModal");
        if (answer === '') {
            changeModalTitle('Error');
            changeModalText('La respuesta no puede estar vacía');
            changeModalType('alert');
            modal.style.display = "block";
        } else {
            const data = {
                id: userResetData.id,
                security_question: selectedQuestion,
                security_answer: answer
            };
            const response = await fetchBody('change_security_question_admin', 'PUT', data);
            if (response.success) {
                changeModalTitle('Éxito!');
                changeModalText('La pregunta de seguridad se restableció exitosamente!');
                changeModalType('alert');
                modal.style.display = "block";
                changeCurrentMenu('active-users');
            } else {
                changeModalTitle('Error al intentar la operación');
                changeModalText(response.reason);
                changeModalType('alert');
                modal.style.display = "block";
            }
        }
    }

  return (
    <motion.div
        id='adminResetUserQuestionCard'
        key='adminResetUserQuestion'
        initial={{opacity: 0, x: -1000}}
        animate={{opacity: 1, x: 0}}
        exit={{opacity: 0, x: -1000, transition:{duration: 0.5, delay: 0}}}
        transition={{duration: 0.5}}>
          <Card hasBackNavigation={true} backNavigationFunction={changeCurrentMenu} backNavigationTarget={'restore-user'}>
            <h2>Pregunta de seguridad para {userResetData.name}</h2>
            <Select options={questions} changeEvent={changeSelectedQuestion} label='Pregunta de seguridad' />
            <TextInputHorizontalTag label='Respuesta de seguridad' inputClass='adminInput' changeEvent={changeAnswer} />
            <br />
            <ButtonFunction buttonFunction={newQuestionFunction} buttonClass='adminButton' >Restablecer</ButtonFunction>
          </Card>
    </motion.div>
  )
}

export default RestoreUserQuestion